"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DEFAULT_COLOR = "#ff5600";
const DEFAULT_SIZE = 100;
class Spinner extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            color: DEFAULT_COLOR,
            size: DEFAULT_SIZE
        };
    }
    static getDerivedStateFromProps(props, state) {
        return {
            color: props.color || DEFAULT_COLOR,
            size: isNaN(props.size) ? DEFAULT_SIZE : props.size
        };
    }
    render() {
        return (react_1.default.createElement("svg", { width: `${this.state.size}px`, height: `${this.state.size}px`, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMid" },
            react_1.default.createElement("path", { stroke: "none", d: "M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50", fill: this.state.color },
                react_1.default.createElement("animateTransform", { attributeName: "transform", type: "rotate", calcMode: "linear", values: "0 50 51;360 50 51", keyTimes: "0;1", dur: "1s", begin: "0s", repeatCount: "indefinite" }))));
    }
}
exports.Spinner = Spinner;
